"use strict";
/**
 * WARNING: This file is auto-generated
 *
 * DO NOT UPDATE MANUALLY!
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});